module.exports = __webpack_public_path__ + "src/img/disk.d6b68597.png";